import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||46}
    height={undefined}
    style={{aspectRatio:46/37}}
    fill="none"
    viewBox="0 0 46 37"
    {...props}
  >
    <path
      fill="#00E9BA"
      d="M16.431.787H1.566C.848.787.263 1.369.263 2.082v26.03c0 .714.585 1.296 1.303 1.296h14.865c2.845 0 5.174 2.297 5.174 5.123 0 .714.568 1.296 1.286 1.296.718 0 1.304-.582 1.304-1.802l.51-25.525c0-3.746-3.993-7.713-8.274-7.713Zm5.156 8.22v19.252c-1.41-1.252-3.23-2.456-5.156-2.456H3.89V4.389H16.43c2.845 0 5.156 1.792 5.156 4.617Z"
    />
    <path
      fill="#3F538D"
      d="M44.216.787H29.35c-4.28 0-7.764 3.967-7.764 7.713v25.525c-.076 1.427.586 1.802 1.304 1.802.718 0 1.303-.582 1.303-1.296 0-2.826 2.312-5.123 5.157-5.123h14.865c.718 0 1.303-.582 1.303-1.295V2.082c0-.713-.585-1.295-1.303-1.295Zm-2.323 3.602v21.416H29.351c-1.925 0-3.234 1.205-4.647 2.457V9.006c0-2.823 1.802-4.617 4.647-4.617h12.542Z"
    />
    <path
      fill="#FF6E58"
      d="M43.289 30.961H30.524c-2.5 0-4.532 2.022-4.532 4.504 0 .713.586 1.295 1.304 1.295.718 0 1.303-.582 1.303-1.295a1.92 1.92 0 0 1 1.925-1.913H43.29c.718 0 1.303-.582 1.303-1.295 0-.714-.585-1.296-1.303-1.296Z"
    />
    <path
      fill="#3F538D"
      d="M15.497 30.961H2.732c-.718 0-1.303.582-1.303 1.296 0 .713.585 1.295 1.303 1.295h12.765a1.92 1.92 0 0 1 1.925 1.913c0 .713.585 1.295 1.303 1.295s1.304-.582 1.304-1.295c0-2.485-2.034-4.504-4.532-4.504Z"
    />
  </svg>
)
export default SvgComponent
